module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"homepage":"Homepage","pageNotFound":"Page Not Found","paragraph":"That page cannot be found. You can return to our homepage clicking on the button bellow"}}')
  delete Component.options._Ctor
}
